import { Api } from './Api';

export function* getLevels() {
    const jsonData = yield Api.get("/levels/ss");
    return jsonData;
}